import React from 'react'
import {
    Box,
    Text,
    SimpleGrid,
    useStyleConfig,
    VStack,
    Button,
    Flex,
    Divider,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import useCountries from '../../hooks/use-countries'
import {useGetCountrySelector} from '../../custom-api/hooks/use-get-country-selector'
import {remCalc} from '../../theme/_utils'
import {Country} from '../../components/footer/country-selector'
import {absoluteUrl} from '../../utils/url'
import useCurrentHost from '../../hooks/use-current-host'

const SplashPage = ({intl}) => {
    const styles = useStyleConfig('CountrySelectorFooter')
    const {data} = useGetCountrySelector()
    const countries = useCountries(data)
    const {getHost} = useCurrentHost()
    const origin = getHost()

    return (
        <Flex layerStyle={'page'}>
            <Box margin="0 auto" padding={{base: 4, lg: 8}}>
                <Box textAlign={{base: 'center', lg: 'left'}} mb={{base: remCalc(6), lg: 8}}>
                    <Text {...styles?.headerText} pb={remCalc(16)}>
                        {data?.selector_title}
                    </Text>
                    <Divider orientation="horizontal" />
                </Box>

                <Flex flexDir={'column'} gap={{lg: remCalc(64)}}>
                    {countries.map((dataSet, idx) => (
                        <Box {...styles?.region} key={idx}>
                            <Text {...styles?.textHeader}>{dataSet.region}</Text>
                            <SimpleGrid {...styles?.selectorGrid}>
                                {Object.entries(dataSet.countries).map(([countryCode, locales]) => (
                                    <Country
                                        key={countryCode}
                                        locales={locales}
                                        countryCode={countryCode}
                                        intl={intl}
                                        isAbsoluteUrl={true}
                                    />
                                ))}
                            </SimpleGrid>
                        </Box>
                    ))}
                </Flex>

                <Box as="footer" mt={8} textAlign="center">
                    <VStack {...styles?.footerContent}>
                        <Text {...styles?.textFooterHeader}>{data?.international_title}</Text>
                        <Text {...styles?.footerText}>{data?.international_description}</Text>
                        <Button
                            as="a"
                            w={remCalc(331)}
                            href={absoluteUrl(data?.international_cta?.href, origin)}
                            variant="primary"
                        >
                            {data?.international_cta?.title}
                        </Button>
                    </VStack>
                </Box>
            </Box>
        </Flex>
    )
}

SplashPage.propTypes = {
    intl: PropTypes.object,
}

export default SplashPage
